import { render, staticRenderFns } from "./EditSubjectModal.vue?vue&type=template&id=67ec9202&scoped=true&"
import script from "./EditSubjectModal.vue?vue&type=script&lang=js&"
export * from "./EditSubjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ec9202",
  null
  
)

export default component.exports